import * as React from 'react';

import { get as getUser } from 'js/lib/user';

import CoachIcon from 'bundles/ai-coach-platform/components/branding/CoachIcon';
import { LearnerAvatar } from 'bundles/ai-coach-platform/components/building-blocks';
import type { CoachPersona } from 'bundles/ai-coach-platform/components/patterns/chat/types';
import { firstNameFromFullName } from 'bundles/ai-coach-platform/utils/nameParser';

export const getCoachPersona = (): CoachPersona => ({
  name: 'Coach', // 'Coach' is intentionally not translated since it is a product name
  avatar: <CoachIcon size="medium" />,
});

export const getLearnerPersona = (profileClientAvatar?: string): CoachPersona => {
  const { fullName } = getUser();
  const name = firstNameFromFullName(fullName);
  const avatar = <LearnerAvatar imageUrl={profileClientAvatar} name={name} />;

  return { name, avatar };
};
